<!-- <app-modal [template]="templateSpecialPayments"></app-modal> -->
<app-preloader *ngIf="isLoading"></app-preloader>

<div>
  <div class="payments">
    <!-- <div class="tableWrapper"> -->
    <!-- Tabla Pagos especiales -->
    <!-- <div class="customTable pagosEspecialesCards">
        <div class="header">
          <div class="cell numero">Nº</div>
          <div class="cell mes">Mes</div>
          <div class="cell tipo">Tipo de Pago</div>
          <div class="cell importe">Importe</div>
          <div class="cell tipo">Aplica a</div>

          <div class="cell acciones" *ngIf="!isEdit"></div>
        </div>

        <div class="row" *ngFor="let item of listPayments; let i = index">
          <div class="cell numero">{{ item.period }}</div>
          <div class="cell mes">
            {{ formatDateMonthAndYear(item.paymentDate) }}
          </div>
          <div class="cell tipo">{{ getPaymentType(item.paymentType) }}</div>
          <div class="cell importe">{{ item.amount | currency : "" : "" }}</div>
          <div class="cell tipo">{{ getApplyTo(item.applyTo) }}</div>
          <div class="cell acciones" *ngIf="!isEdit">
            <a (click)="edit(item)" class="edit" tp="Editar pago especial"
              >Editar</a
            >
            <a
              (click)="openModalConfirmation(item)"
              class="delete"
              tp="Eliminar pago especial"
              >Eliminar</a
            >
          </div>
        </div>
      </div>
    </div> -->

    <div class="pagosEspecialesCards">
      @for(item of listPayments; track i; let i = $index){
      <div class="card" [ngClass]="getPaymentClass(item.paymentType)">
        <div class="header">
          <h3>
            <span class="type">Nº </span>{{ item.period }}
            <span class="type">Mes </span
            >{{ formatDateMonthAndYear(item.paymentDate) }}
          </h3>

          <!-- Incluir la clase "active" cuando se está mostrando el menú-->
          @if(!isEdit && !isCalculateDisable()){ @if(getRowKey(item.id, i); as itemId){
          <div
            class="contextualMenuMobile"
            [ngClass]="{ active: isMenuRowOpen(itemId) }"
          >
            <a
              class="toggle"
              aria-haspopup="menu"
              aria-controls="menu-id"
              role="button"
              [id]="'menu-' + itemId"
              (click)="toggleMenuOptions($event, itemId)"
              >Ver/Ocultar menu</a
            >
            <div
              class="menuContent"
              role="menu"
              id="menu-id"
              style="z-index: 40"
              appBackdropOverlay
              appOutSideClick
              [ignoreElements]="['menu-' + itemId]"
              [isActive]="!!menuActive()"
              [activeTarget]="menuActive()"
              [currentTarget]="itemId"
              (outSideClick)="closeMenuOptions()"
            >
              <ul>
                <li role="menuitem">
                  <a class="iconAndText edit" (click)="edit(item)">
                    Editar período de gracia</a
                  >
                  <a
                    class="iconAndText delete"
                    (click)="openModalConfirmation(item)"
                  >
                    Eliminar período de gracia</a
                  >
                </li>
              </ul>
            </div>
          </div>
          } }
        </div>
        <div class="row">
          <span>Tipo de pago</span>
          <span>{{ getPaymentType(item.paymentType) }}</span>
        </div>
        <div class="row">
          <span>Aplica a</span>
          <span>{{ getApplyTo(item.applyTo) }}</span>
        </div>
        <div class="row">
          <span>Importe</span>
          <span>{{ item.amount | currency : "" : "" }}</span>
        </div>
      </div>
      }
    </div>

    <div class="mainWrapper">
      <div class="tableWrapper">
        <button class="tertiary" (click)="newSpecialPayment()" *ngIf="!isEdit && !isCalculateDisable()">
          <i class="icon"></i>
          Nuevo período de gracia o pago especial
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #modalPayments>
  <app-grace-special-payments
    [quoteType]="this.quoteType"
    [period]="period"
    [periodList]="periodList"
    [idQuote]="idQuote"
    [idDeal]="idDeal"
    [financialProduct]="financialProduct"
    (newPayment)="update($event)"
    (deletePayment)="delete($event)"
  ></app-grace-special-payments>
</ng-template>

<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="delete(period)"
  ></app-template-confirmation>
</ng-template>
